import type { DeliveryData } from "../../types/DeliveryData";
import type { LegacyPortalPurchaseHistoryShippingAddress } from "@spwn-portal/grpc";

/**
 * 決済時の配送先住所スナップショット（Shopify注文）をお届け先表示へ。
 * Shopifyの住所は都道府県・市区町村・番地が別フィールドなので連結する
 */
export const convertShippingAddressToDeliveryData = (
  address: LegacyPortalPurchaseHistoryShippingAddress
): DeliveryData => ({
  recipientName:
    address.name ?? `${address.lastName ?? ""}${address.firstName ?? ""}`,
  postalCode: address.zip ?? "",
  mainAddress: `${address.province ?? ""}${address.city ?? ""}${address.address1 ?? ""}`,
  subAddress: address.address2 ?? "",
});
